import IBoardData from "./IBoardData";

class Boards {

  public static instance: Boards | null = null;

  private path: string;
  private mChildren: { [id: string]: IBoardData };

  private constructor(path: string) {
    this.path = path;
    this.mChildren = {};
  }

  public static init(path: string): void {
    if (Boards.instance == null) {
      Boards.instance = new Boards(path);
    }
  }

  public request(): Promise<string | void> {
    return fetch(this.path)
      .then((response: Response) => response.json())
      .then((json: IBoardData[]) => {
        this.mChildren = {};

        for (let child of json) {
          // Use the first override name if it exists
          if (child.OverrideNames != null) {
            if (child.OverrideNames.length > 0) {
              child.Name = child.OverrideNames[0];
            }
          }

          this.mChildren[child.ID] = child;
        }

        return new Promise<string>(
          (resolve, reject) => {
            resolve("Fetching Boards ready!");
            reject("Fetching Boards failed!");
          },
        );
      })
      .catch((error: any) => {
        console.error("Error loading JSON:", error);
      });
  }

  public findByID(id: string): IBoardData | null {
    const child = this.mChildren[id];
    return (child ? child : null);
  }

  public first(): IBoardData | null {
    const first = this.mChildren[Object.keys(this.mChildren)[0]];
    return (first ? first : null);
  }

  public children(): IBoardData[] {
    return Object.values(this.mChildren);
  }
}

export default Boards;
